enum LOAI_PHIEU_KHO {
  NHAP = "NH",
  XUAT = "XU",
  DU_TRU = "DT",
}
enum TT_PHIEU_KHO {
  NHAP = "NH",
  CHO_DUYET = "CD",
  DA_DUYET = "DD",
  HOAN_THANH = "HT",
  HUY_PHIEU = "HP",
  TU_CHOI = "TC",
}
enum LOAI_FORM {
  TAO_MOI = "TAO_MOI",
  DA_TAO = "DA_TAO",
  TAO_MOI_PT = "TAO_MOI_PT",
}
enum TT_THUOC {
  ALL = "ALL",
  CON_HAN = "CH",
  GAN_HAN = "GH",
  QUA_HAN = "QH",
  HET_HAN = "HH",
}
enum TT_VTYT {
  BINH_THUONG = "BT",
  GAN_HET_HAN = "GHH",
  HET_HAN = "HH",
  HET = "H",
}
export {LOAI_PHIEU_KHO, TT_PHIEU_KHO, LOAI_FORM, TT_THUOC, TT_VTYT};
